import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "@popperjs/core/dist/umd/popper.min.js";
import "./src/assets/css/global.scss";
import type { GatsbyBrowser } from "gatsby";

// In development, Gatsby shows a generic "dev-404-page" with a "Preview custom 404 page" button.
// This automatically triggers the custom 404 preview so developers and users immediately see
// the custom 404 page without having to manually click the button.
export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = () => {
  if (process.env.NODE_ENV === "development") {
    const triggerCustom404 = () => {
      const buttons = document.querySelectorAll("button");
      for (const btn of buttons) {
        if (btn.textContent && btn.textContent.includes("Preview custom 404")) {
          btn.click();
          return true;
        }
      }
      return false;
    };

    if (!triggerCustom404()) {
      setTimeout(triggerCustom404, 50);
      setTimeout(triggerCustom404, 200);
    }
  }
};

